
// Fix: Define an interface for completed test objects to resolve type errors.
interface CompletedTest {
    duration: number;
    score: number;
    no_q: number;
}

// Fix: Type the function parameter to ensure `completedTests` has the correct shape.
export const calculateUserStats = (completedTests: { [key: string]: CompletedTest } | null | undefined) => {
    const defaultStats = {
        accuracy: 0,
        totalTime: "0h 0m",
        totalTests: 0,
        averageScore: 0,
    };

    if (!completedTests) {
        return defaultStats;
    }

    const tests = Object.values(completedTests);
    if (tests.length === 0) {
        return defaultStats;
    }

    const totalTests = tests.length;

    // Calculate total time
    const totalMinutes = tests.reduce((sum, test) => sum + test.duration, 0);
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    const totalTime = `${hours}h ${minutes}m`;

    // Calculate accuracy and average score
    const totalScore = tests.reduce((sum, test) => sum + test.score, 0);
    const totalMaxScore = tests.reduce((sum, test) => sum + (test.no_q * 4), 0);
    
    const accuracy = totalMaxScore > 0 ? Math.round((totalScore / totalMaxScore) * 100) : 0;
    const averageScore = totalTests > 0 ? Math.round(totalScore / totalTests) : 0;
    
    return { 
        accuracy: Math.max(0, accuracy), // Ensure accuracy is not negative
        totalTime,
        totalTests,
        averageScore,
    };
}
